import { mergeModules } from "../core"
import reducer from "./reducer"
import list from "./list"

export default mergeModules({
  ...list,
  reducer,
})
